export default __webpack_public_path__ + "64bd647373a234bd8ea97d438b10ee71.png";